import { Injectable } from "@angular/core";

export type NotificationLevel = "warning" | "error" | "message" ;

@Injectable()
export abstract class NotificationHandler {

  abstract handle(level: NotificationLevel, title: string, message: string): void;

}


